<ion-header [translucent]="true" class="ninja">
  <ion-toolbar class="thin-toolbar" mode="ios">
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" [forceOverscroll]="false">
  <ng-container [ngSwitch]="state">
    <tablesready-login
      *ngSwitchCase="loginStates.login"
      (toggle)="toggleState($event)"
    ></tablesready-login>
    <tablesready-signup
      *ngSwitchCase="loginStates.signup"
      [planCode]="planCode"
      (onToggle)="toggleState($event)"
    ></tablesready-signup>
    <tablesready-reset-password
      *ngSwitchCase="loginStates.resetPassword"
      (onToggle)="toggleState($event)"
    ></tablesready-reset-password>
    <tablesready-set-password
      *ngSwitchCase="loginStates.setPassword"
    ></tablesready-set-password>
  </ng-container>
</ion-content>

